module.exports = __webpack_public_path__ + "img/ecu_banner.9ab40bee.jpg";